module.exports = __webpack_public_path__ + "static/rightHeadphones-5a1f1097e2e1ffb5c9992bf89d823b8e.svg";